// extracted by mini-css-extract-plugin
export var hideEditor = "_iz-2";
export var infoIcon = "_iz-3";
export var label = "_iz-1";
export var labelContainer = "_iz-0";
export var readonlyText = "_iz-4";